
import { useState } from 'react';

export const useInterviewTabs = () => {
  const [activeTab, setActiveTab] = useState('create');

  const handleRequestSuccess = () => {
    setActiveTab('manage');
  };

  return {
    activeTab,
    setActiveTab,
    handleRequestSuccess
  };
};
